module.exports = __webpack_public_path__ + "img/icon_clipboard.18ae34a2.svg";